var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRacketSports = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Ping-Pong-Paddle--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Ping Pong Paddle Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.57 11.63a0.23 0.23 0 0 0 -0.28 -0.05 0.27 0.27 0 0 0 -0.15 0.24 9.43 9.43 0 0 0 1.06 3.82 0.5 0.5 0 0 1 -0.09 0.59L1.31 20a1.51 1.51 0 0 0 0 2.12l1.42 1.41a1.49 1.49 0 0 0 1.06 0.47 1.51 1.51 0 0 0 1.06 -0.44l3.8 -3.8a0.5 0.5 0 0 1 0.58 -0.09 9.53 9.53 0 0 0 3.83 1.07 0.26 0.26 0 0 0 0.25 -0.15 0.25 0.25 0 0 0 -0.06 -0.28Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.62 1.75 -0.6 0a0.48 0.48 0 0 0 -0.37 0.2 0.51 0.51 0 0 0 -0.09 0.41 5.2 5.2 0 0 1 0.13 1.12 5 5 0 0 1 -5 5 4.91 4.91 0 0 1 -2.35 -0.59 0.51 0.51 0 0 0 -0.42 0 0.48 0.48 0 0 0 -0.29 0.3A7.32 7.32 0 0 0 4.4 9a0.48 0.48 0 0 0 0.13 0.48l10.88 10.87a0.5 0.5 0 0 0 0.47 0.13 9.5 9.5 0 0 0 -2.26 -18.73Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69 7a3.5 3.5 0 1 0 -3.5 -3.5A3.5 3.5 0 0 0 7.69 7Zm0 -5a1.5 1.5 0 1 1 -1.5 1.5A1.5 1.5 0 0 1 7.69 2Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRacketSports);
export default ForwardRef;